export default "__VITE_ASSET__BiFV$a51__"